import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-69276373"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top12-center" }
const _hoisted_2 = { class: "top12-title" }
const _hoisted_3 = { class: "bottomBar" }
const _hoisted_4 = { class: "bottomBar-center" }
const _hoisted_5 = { class: "bottomBar-left" }
const _hoisted_6 = { class: "left-title" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left-title1" }, "联系电话：", -1))
const _hoisted_8 = { class: "left-title2" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left-title3" }, "公司地址：", -1))
const _hoisted_10 = { class: "left-title4" }
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"bottomBar-right\" data-v-69276373><div class=\"right-menu1\" data-v-69276373><div class=\"menu1\" data-v-69276373>首页</div><div class=\"menu\" data-v-69276373>平台优势</div><div class=\"menu\" data-v-69276373>主要业务</div><div class=\"menu\" data-v-69276373>小二兼职</div><div class=\"menu\" data-v-69276373>悦客联盟</div><div class=\"menu\" data-v-69276373>项目保</div><div class=\"menu\" data-v-69276373>软件定制</div></div><div class=\"right-menu2\" data-v-69276373><div class=\"menu1\" data-v-69276373>关于我们</div><div class=\"menu\" data-v-69276373>公司简介</div><div class=\"menu\" data-v-69276373>平台公告</div></div><div class=\"right-menu3\" data-v-69276373><div class=\"menu1\" data-v-69276373>联系我们</div><div class=\"menu\" data-v-69276373>联系方式</div></div></div>", 1)

import { onMounted, ref } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'bottomBar',
  setup(__props) {

// import { homeInfo } from "@/api/home.js"
const infoList = ref<any>({})

infoList.value = JSON.parse(localStorage.getItem("info"))


const goView = (url: any) => {
  window.open(url)
}

onMounted(() => {
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "top12",
      style: _normalizeStyle({ backgroundImage: `url(${infoList.value?.bottom_banner?.image})` })
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(infoList.value?.bottom_banner?.title), 1),
        _createElementVNode("div", {
          class: "top12-btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (goView(infoList.value?.set?.kefu_url)))
        }, "立即咨询")
      ])
    ], 4),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(infoList.value?.set?.site_name), 1),
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, _toDisplayString(infoList.value?.set?.site_phone), 1),
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, _toDisplayString(infoList.value?.set?.site_address), 1)
        ]),
        _hoisted_11
      ])
    ])
  ]))
}
}

})